"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _reduxForm = require("redux-form");

var _reactRedux = require("react-redux");

var _Form = require("../../form/Form");

var _keyHelpers = require("../../utils/keyHelpers");

var _validation = require("../../validation");

var _index = require("../../types/index");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _index.ComponentElementDefinition;
});

var InheritedComponentValidation = _flowRuntime["default"].tdz(function () {
  return _index.InheritedComponentValidation;
});

var FieldProps = _flowRuntime["default"].tdz(function () {
  return _reduxForm.FieldProps;
});

var Node = _flowRuntime["default"].tdz(function () {
  return _react.Node;
});

var ComponentType = _flowRuntime["default"].tdz(function () {
  return _react.ComponentType;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].exactObject(_flowRuntime["default"].property("component", _flowRuntime["default"].ref(ComponentElementDefinition)), _flowRuntime["default"].property("fields", _flowRuntime["default"].object()), _flowRuntime["default"].property("hideComponentLabel", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("hideContinueOnError", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("inheritedComponentValidation", _flowRuntime["default"].array(_flowRuntime["default"].ref(InheritedComponentValidation)), true), _flowRuntime["default"].property("parentKey", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("renderComponent", _flowRuntime["default"]["function"](_flowRuntime["default"]["return"](_flowRuntime["default"].ref(Node)))), _flowRuntime["default"].property("showErrorsWhenAnyTouched", _flowRuntime["default"].array(_flowRuntime["default"].string()), true)));

var RenderComponentProps = _flowRuntime["default"].type("RenderComponentProps", _flowRuntime["default"].object(_flowRuntime["default"].property("componentKey", _flowRuntime["default"].string()), _flowRuntime["default"].property("error", _flowRuntime["default"].any(), true)));

var RenderProps = _flowRuntime["default"].type("RenderProps", _flowRuntime["default"].intersection(_flowRuntime["default"].exactObject(_flowRuntime["default"].property("componentKey", _flowRuntime["default"].string()), _flowRuntime["default"].property("componentObject", _flowRuntime["default"].ref(ComponentElementDefinition)), _flowRuntime["default"].property("fields", _flowRuntime["default"].object()), _flowRuntime["default"].property("hideButton", _flowRuntime["default"]["function"](_flowRuntime["default"]["return"](_flowRuntime["default"]["void"]()))), _flowRuntime["default"].property("hideComponentLabel", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("hideContinueOnError", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("renderComponent", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", RenderComponentProps), _flowRuntime["default"]["return"](_flowRuntime["default"].ref(Node)))), _flowRuntime["default"].property("showErrorsWhenAnyTouched", _flowRuntime["default"].array(_flowRuntime["default"].string()))), _flowRuntime["default"].ref(FieldProps)));

var mapStateToProps = function mapStateToProps(state) {
  return {
    fields: (0, _reduxForm.getFormMeta)('form')(state)
  };
};

var FormComponentWrapperRender = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(FormComponentWrapperRender, _React$Component);

  var _super = (0, _createSuper2["default"])(FormComponentWrapperRender);

  function FormComponentWrapperRender() {
    (0, _classCallCheck2["default"])(this, FormComponentWrapperRender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _super.call.apply(_super, [this].concat(args));
  }

  (0, _createClass2["default"])(FormComponentWrapperRender, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          hideButton = _this$props.hideButton,
          hideContinueOnError = _this$props.hideContinueOnError,
          error = _this$props.meta.error;

      if (hideContinueOnError && error !== prevProps.meta.error) {
        hideButton();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          componentObject = _this$props2.componentObject,
          componentKey = _this$props2.componentKey,
          fields = _this$props2.fields,
          hideComponentLabel = _this$props2.hideComponentLabel,
          _this$props2$meta = _this$props2.meta,
          error = _this$props2$meta.error,
          warning = _this$props2$meta.warning,
          renderComponent = _this$props2.renderComponent,
          showErrorsWhenAnyTouched = _this$props2.showErrorsWhenAnyTouched;

      var componentError = function componentError() {
        if (showErrorsWhenAnyTouched.some(function (key) {
          return _lodash["default"].get(fields, "".concat(componentKey, ".").concat(key, ".touched"));
        }) && error) {
          return true;
        }

        return false;
      };

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: componentError() ? 'error-box group' : 'group'
      }, !hideComponentLabel && componentObject.label && /*#__PURE__*/_react["default"].createElement("h2", null, componentObject.label), renderComponent && renderComponent({
        componentKey: componentKey,
        error: error
      }), showErrorsWhenAnyTouched.some(function (key) {
        return _lodash["default"].get(fields, "".concat(componentKey, ".").concat(key, ".touched"));
      }) && error && /*#__PURE__*/_react["default"].createElement("span", {
        className: "error-message"
      }, error) || warning && /*#__PURE__*/_react["default"].createElement("span", {
        className: "warn-message"
      }, warning));
    }
  }]);
  return FormComponentWrapperRender;
}(_react["default"].Component);
/**
 * This 'field' is responsible for component level validation, and will only render error messaging for failed validation
 *
 * @param componentValidationRules
 * An array of validators to be run for the component
 * @param showErrorsWhenAnyTouched
 * An array of child field keys - will not show validation until on of these has been touched
 * @param fields
 * Meta data for all redux-form fields, from redux. Used to determine which fields have been touched
 * @param component
 * The component
 */


var FormComponentWrapper = function FormComponentWrapper(_arg) {
  var component = _arg.component,
      fields = _arg.fields,
      hideContinueOnError = _arg.hideContinueOnError,
      hideComponentLabel = _arg.hideComponentLabel,
      parentKey = _arg.parentKey,
      renderComponent = _arg.renderComponent,
      showErrorsWhenAnyTouched = _arg.showErrorsWhenAnyTouched,
      inheritedComponentValidation = _arg.inheritedComponentValidation;
  var componentKey = (0, _keyHelpers.compositeKey)(parentKey, component.key);
  var inheritedComponentRules = (0, _validation.getInheritedComponentValidation)(component.key, inheritedComponentValidation);
  var componentValidationRules = (0, _validation.getComponentValidationRules)(component, componentKey, inheritedComponentRules);
  return /*#__PURE__*/_react["default"].createElement(_Form.ButtonContext.Consumer, null, function (_ref) {
    var hideButton = _ref.hideButton;
    return /*#__PURE__*/_react["default"].createElement(_reduxForm.FormSection, {
      name: component.key
    }, /*#__PURE__*/_react["default"].createElement("fieldset", {
      id: componentKey,
      className: component.type
    }, /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, {
      component: FormComponentWrapperRender,
      componentKey: componentKey,
      componentObject: component,
      fields: fields,
      hideButton: hideButton,
      hideComponentLabel: hideComponentLabel,
      hideContinueOnError: hideContinueOnError,
      inheritedComponentValidation: inheritedComponentRules,
      key: "".concat(componentKey, "-component-validator"),
      name: "component-validator",
      renderComponent: renderComponent,
      showErrorsWhenAnyTouched: showErrorsWhenAnyTouched,
      validate: componentValidationRules
    })));
  });
};

FormComponentWrapper.defaultProps = {
  parentKey: undefined,
  inheritedComponentValidation: undefined,
  showErrorsWhenAnyTouched: []
}; // $FlowFixMe WEB-352

var _default = (0, _reactRedux.connect)(mapStateToProps)(FormComponentWrapper);

exports["default"] = _default;